import { render, staticRenderFns } from "./CategorySubChildren.vue?vue&type=template&id=591292b9&scoped=true&"
import script from "./CategorySubChildren.vue?vue&type=script&lang=ts&"
export * from "./CategorySubChildren.vue?vue&type=script&lang=ts&"
import style0 from "./CategorySubChildren.vue?vue&type=style&index=0&id=591292b9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591292b9",
  null
  
)

export default component.exports